module.exports = __webpack_public_path__ + "img/buyPremium.e7308a9b.svg";